import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import {
  isAgencyAdmin,
  isAgencyUser,
  isRolePlatformAdmin,
  token,
} from "../../../modules/auth";
import { isCompanyAdmin, isCompanyUser } from "../../../modules/permissions";
import PreferredProgrammeFilters from "../../../Components/PreferredProgrammes/PreferredProgrammeFilters";
import {
  fetchHotelGroup,
  fetchSnapshotBasedOnHotelGroupsReport,
  snapshotReportHotelGroupUnload,
} from "../../../redux/actions";
import * as ROUTES from "../../../Router/venue_routes";
import Loading from "../../../Components/Loading";
import { withRouter, Link } from "react-router-dom";
import PreferredProgrammeSnapshotReportTable from "../../../Components/PreferredProgrammes/PreferredProgrammeSnapshotReportTable";
import { fetchVenue } from "../../../redux/actions/venues";
import { ButtonBrand } from "../../../Components/Button";

let PreferredProgrammeVenueViewContainer = ({
  venueId,
  token,
  venue,
  hotelGroup,
  hotelGroupNotFound,
  fetchVenue,
  fetchHotelGroup,
  fetchSnapshotBasedOnHotelGroupsReport,
  snapshotReport,
  snapshotReportForHotelGroups,
  programmeId,
  snapshotReportHotelGroupUnload,
  isPlatformAdmin
}) => {
  const [snapShot, setSnapshot] = useState(null);
  const [snapShotHG, setSnapshotHG] = useState(null);
  const [snapShotToDisplay, setSnapShotToDisplay] = useState(false);
  const showDataBasedOnHistoricalVenueGroups = true;
  useEffect(() => {
    fetchVenue(venueId, token);
    fetchHotelGroup(programmeId, token, null, true);
    return () => {
      setSnapshotHG(null);
      setSnapshot(null);
      setSnapShotToDisplay(null);
      snapshotReportHotelGroupUnload();
    };
  }, []);

  useEffect(() => {
    if (snapshotReport) {
      snapshotReport.find(report => {
        let yearToDate = report.find(report => {
          return report.key === "yearToDate";
        });
        setSnapshot(yearToDate);
        if (snapShotToDisplay === null) {
          setSnapShotToDisplay(yearToDate);
        }
      });
    }
  }, [snapshotReport]);

  useEffect(() => {
    if (snapshotReportForHotelGroups) {
      snapshotReportForHotelGroups.find(report => {
        let yearToDate = report.find(report => {
          return report.key === "yearToDate";
        });
        setSnapshotHG(yearToDate);
        setSnapShotToDisplay(yearToDate);
      });
    }
  }, [snapshotReportForHotelGroups]);

  useEffect(() => {
    if (showDataBasedOnHistoricalVenueGroups) {
      setSnapShotToDisplay(snapShotHG);
    } else {
      setSnapShotToDisplay(snapShot);
    }
  }, [showDataBasedOnHistoricalVenueGroups]);

  useEffect(() => {
    let queryParams = {};

    if (programmeId) {
      queryParams = { ...queryParams, hotelGroups: programmeId, preferredProgramme: programmeId };
    }
    if (venue) {
      queryParams = { ...queryParams, limitToVenue: venue.id };

      setSnapShotToDisplay(null);
      setSnapshot(null);
      setSnapshotHG(null);
      fetchSnapshotBasedOnHotelGroupsReport(
        token,
        queryParams
      );
    }
  }, [venue]);

  if (!snapShotToDisplay) {
    return <Loading />;
  }
  let displayAddress = (
    address1,
    address2,
    address3,
    city,
    county,
    postcode,
    country
  ) => {
    if (
      !address1 &&
      !address2 &&
      !address3 &&
      !city &&
      !county &&
      !postcode &&
      !country
    ) {
      return <div className={"py-2"}>Not Provided</div>;
    }
    return (
      <div className={"py-2"}>
        <ul className="list-reset mb-3">
          {address1 && <li className="mb-1">{address1}</li>}
          {address2 && <li className="mb-1">{address2}</li>}
          {address3 && <li className="mb-1">{address3}</li>}
          {city && <li className="mb-1">{city}</li>}
          {county && <li className="mb-1">{county}</li>}
          {postcode && <li className="mb-1">{postcode}</li>}
          {country && <li className="mb-1">{country}</li>}
        </ul>
      </div>
    );
  };
  return (
    <div>
      {/*<a className={"text-black"} onClick={() => {*/}
      {/*  setSelectedBrand(null);*/}
      {/*  let programme = selectedCompany ? selectedCompany.preferredProgramme : (selectedAgency ? selectedAgency.preferredProgramme : myProgrammeId)*/}
      {/*  redirect(hotelGroup.parentGroup.id, programme);*/}
      {/*}}>{"<"} Go Back To {hotelGroup.parentGroup.name} </a>*/}
      <div className="border-b border-gray-200 bg-white p-5">
        <div>
          <Link
            to={isPlatformAdmin ? ROUTES.FRONTEND.PREFERRED_PROGRAMMES.INDEX : ROUTES.FRONTEND.PREFERRED_PROGRAMMES.MY}
            className={"font-bold text-black "}
          >
            My Programme{" > "}
          </Link>
          {window.localStorage.getItem("ppAgency") ? (
            <Link
              to={window.localStorage.getItem("ppAgency").split("|")[1]}
              className={"font-bold text-black "}
            >
              {window.localStorage.getItem("ppAgency").split("|")[0]} {" > "}
            </Link>
          ) : null}
          {window.localStorage.getItem("ppCompany") ? (
            <Link
              to={window.localStorage.getItem("ppCompany").split("|")[1]}
              className={"font-bold text-black "}
            >
              {window.localStorage.getItem("ppCompany").split("|")[0]}
              {" > "}
            </Link>
          ) : null}
          {window.localStorage.getItem("ppGroup") ? (
            <Link
              to={window.localStorage.getItem("ppGroup").split("|")[1]}
              className={"font-bold text-black "}
            >
              {window.localStorage.getItem("ppGroup").split("|")[0]}
              {" > "}
            </Link>
          ) : null}
          {window.localStorage.getItem("ppBrand") ? (
            <Link
              to={window.localStorage.getItem("ppBrand").split("|")[1]}
              className={"font-bold text-black "}
            >
              {window.localStorage.getItem("ppBrand").split("|")[0]}
            </Link>
          ) : null}
        </div>
        <h1 className={"py-3"}>{venue.name} </h1>
        {hotelGroup ? (
          <h3 className={"pb-3"}>
            {hotelGroup.agency
              ? hotelGroup.agency.name
              : hotelGroup.company
              ? hotelGroup.company.name
              : ""}{" "}
            Preferred Programme
          </h3>
        ) : null}
      </div>
      <div className="border-b border-gray-200  bg-white p-5">
        <div className={"row"}>
          <div className={`col col-w-1/2`}>
            {/*{group.image ? <div className="bg-white py-2 justify-center">*/}
            {/*  <img*/}
            {/*    alt={group?.name + ' image'}*/}
            {/*    src={`${process.env.REACT_APP_API}/api/hotel-groups/${group.id}/image`}*/}
            {/*    style={{*/}
            {/*      maxWidth: 96,*/}
            {/*    }}*/}
            {/*  />*/}
            {/*</div> : null}*/}
            <div className={"py-2"}>
              <table className={"edge-table-no-stripe ml-0"}>
                <tbody>
                  <tr>
                    <th className={"w-1/3"}>Account Manager:</th>
                  </tr>
                  <tr>
                    <th>Telephone:</th>
                    <td>{venue.phone ? venue.phone : "Not Provided"}</td>
                  </tr>
                  <tr>
                    <th>Email Address:</th>
                    <td>{venue.email ? venue.email : "Not Provided"}</td>
                  </tr>
                  <tr>
                    <th>Website:</th>
                    <td>{venue.website ? venue.website : "Not Provided"}</td>
                  </tr>
                  <tr>
                    <th>Address:</th>
                    <td>
                      {displayAddress(
                        venue?.address1,
                        venue?.address2,
                        venue?.address3,
                        venue?.city,
                        venue?.county,
                        venue?.postcode,
                        venue?.country?.name
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ width: "50%" }}>
                      <ButtonBrand Element={Link} to={"/venue/" + venue.slug}>
                        View Venue Profile
                      </ButtonBrand>
                    </td>
                    <td style={{ width: "50%" }}>
                      <ButtonBrand
                        Element={Link}
                        to={"/request-for-proposal?venues=" + venue.id}
                      >
                        Send Enquiry
                      </ButtonBrand>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className={`col col-w-1/2`}>
            {snapShotToDisplay ? (
              <PreferredProgrammeSnapshotReportTable
                tableData={snapShotToDisplay}
              />
            ) : (
              <Loading />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = (state, props) => {
  return {
    ...state.venue,
    ...state.hotelGroup,
    ...state.snapshotReport,
    ...state.snapshotReportForHotelGroups,
    venueId: props.match.params.id,
    programmeId: props.match.params.programme,
    token: token(state),
    isPlatformAdmin: isRolePlatformAdmin(state)
  };
};

const mapDispatchToProps = {
  fetchVenue,
  fetchHotelGroup,
  fetchSnapshotBasedOnHotelGroupsReport,
  snapshotReportHotelGroupUnload,
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(PreferredProgrammeVenueViewContainer)
);
